import { render, staticRenderFns } from "./productions.vue?vue&type=template&id=ecb086ee"
import script from "./productions.vue?vue&type=script&lang=js"
export * from "./productions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports